/**
 * calima-personalizer-v6.js - Calima Crea
 */

window._calimaQueue = window._calimaQueue || [];

window.CalimaPersonalizer = (function () {

  var CONFIG = {
    personalizacionVariants: {
      1:56765586800966, 2:56765586833734, 3:56765586866502, 4:56765586899270,
      5:56765586932038, 6:56765586964806, 7:56765586997574, 8:56765587030342,
      9:56765587063110, 10:56765587095878, 11:56765587128646, 12:56765587161414,
      13:56765587194182, 14:56765587226950, 15:56765587259718, 16:56765587292486,
      17:56765587325254, 18:56765587358022, 19:56765587390790, 20:56765587423558
    },
    containerSelector: '#calima-personalizer',
    priceDisplaySelector: '#calima-precio-total',
    allowedFileTypes: ['image/jpeg','image/png','image/svg+xml','application/pdf'],
    maxFileSizeMB: 20
  };

  var state = {
    selectedVariantId: null,
    selectedVariantTitle: null,
    basePrice: 0,
    zones: {},
    submitting: false
  };

  function formatPrice(n) { return n.toFixed(2).replace('.', ',') + ' \u20ac'; }
  function getContainer() { return document.querySelector(CONFIG.containerSelector); }
  function readBasePrice() { var c = getContainer(); if (!c) return 0; return c.dataset.basePrice ? parseInt(c.dataset.basePrice, 10) / 100 : 0; }

  function extraerTalla(v) {
    if (!v) return '';
    if (v.selectedOptions && Array.isArray(v.selectedOptions) && v.selectedOptions[0]) return v.selectedOptions[0].value || '';
    if (v.option1) return v.option1;
    if (v.title && v.title.indexOf(' / ') !== -1) return v.title.split(' / ')[0].trim();
    return v.title || '';
  }

  function buscarVarianteEnDOM() {
    var jsonEl = document.querySelector('[data-selected-variant]');
    if (jsonEl && jsonEl.textContent.trim()) {
      try { var v = JSON.parse(jsonEl.textContent.trim()); if (v && v.id) return { id: parseInt(v.id, 10), talla: extraerTalla(v) }; } catch(e) {}
    }
    var inputs = document.querySelectorAll('input[name="id"]');
    for (var i = 0; i < inputs.length; i++) { var val = parseInt(inputs[i].value, 10); if (val > 0) return { id: val, talla: state.selectedVariantTitle || '' }; }
    var c = getContainer();
    if (c && c.dataset.variantId) { var vid = parseInt(c.dataset.variantId, 10); if (vid > 0) return { id: vid, talla: c.dataset.variantTitle || '' }; }
    var m = window.location.search.match(/[?&]variant=(\d+)/);
    if (m) return { id: parseInt(m[1], 10), talla: state.selectedVariantTitle || '' };
    return null;
  }

  function initVariant() { var v = buscarVarianteEnDOM(); if (v) { state.selectedVariantId = v.id; state.selectedVariantTitle = v.talla; } }

  function obtenerPrecioZona(zonaId, tamano) {
    var el = document.querySelector('script[data-zona-precios="' + zonaId + '"]');
    if (!el) return 0;
    try {
      var raw = el.textContent.trim();
      var p = JSON.parse(raw);
      if (typeof p === 'string') p = JSON.parse(p);
      var k = state.selectedVariantTitle;
      if (k && p[k] && p[k][tamano] !== undefined) return parseFloat(p[k][tamano]) || 0;
      if (k && p[k.toUpperCase()] && p[k.toUpperCase()][tamano] !== undefined) return parseFloat(p[k.toUpperCase()][tamano]) || 0;
      if (p['default'] && p['default'][tamano] !== undefined) return parseFloat(p['default'][tamano]) || 0;
      var keys = Object.keys(p); for (var i = 0; i < keys.length; i++) { if (p[keys[i]] && p[keys[i]][tamano] !== undefined) return parseFloat(p[keys[i]][tamano]) || 0; }
    } catch(e) { console.warn('[Calima] Error precios zona', zonaId, e); }
    return 0;
  }

  function calcularTotal() { var t = state.basePrice; for (var id in state.zones) { if (state.zones[id] && state.zones[id].precio) t += state.zones[id].precio; } return t; }
  function calcularPersonalizacion() { var t = 0; for (var id in state.zones) { if (state.zones[id] && state.zones[id].precio) t += state.zones[id].precio; } return t; }
  function actualizarDisplay() { var d = document.querySelector(CONFIG.priceDisplaySelector); if (d) d.textContent = formatPrice(calcularTotal()); }

  function actualizarBotones(zonaId) {
    ['pequeno','mediano','grande'].forEach(function(t) {
      var p = obtenerPrecioZona(zonaId, t);
      var el = document.querySelector('[data-zona-precio-display="' + zonaId + '-' + t + '"]');
      if (el) el.textContent = p > 0 ? '+ ' + formatPrice(p) : '';
    });
  }

  function onVarianteChange(id, talla) {
    state.selectedVariantId = parseInt(id, 10);
    state.selectedVariantTitle = talla || '';
    var c = getContainer();
    if (c) { c.dataset.variantId = state.selectedVariantId; c.dataset.variantTitle = state.selectedVariantTitle; }
    document.querySelectorAll('[data-zona-id]').forEach(function(el) {
      var zid = el.dataset.zonaId; actualizarBotones(zid);
      var z = state.zones[zid];
      if (z && z.tamano) { z.precio = obtenerPrecioZona(zid, z.tamano); var e = document.querySelector('[data-zona-precio-display="' + zid + '"]'); if (e) e.textContent = z.precio > 0 ? '+ ' + formatPrice(z.precio) : ''; }
    });
    actualizarDisplay();
  }

  function onTamanoSelect(zonaId, tamano, label) {
    clearError(zonaId);
    if (!state.zones[zonaId]) state.zones[zonaId] = { tipo: 'A' };
    var p = obtenerPrecioZona(zonaId, tamano);
    state.zones[zonaId].tamano = tamano; state.zones[zonaId].tamanoLabel = label; state.zones[zonaId].precio = p;
    var e = document.querySelector('[data-zona-precio-display="' + zonaId + '"]'); if (e) e.textContent = p > 0 ? '+ ' + formatPrice(p) : '';
    document.querySelectorAll('[data-zona-tamano-opcion="' + zonaId + '"]').forEach(function(b) { var act = b.dataset.tamano === tamano; b.classList.toggle('calima-tamano--activo', act); b.setAttribute('aria-pressed', act ? 'true' : 'false'); });
    actualizarDisplay();
  }

  function onArchivoSubido(zonaId, file) {
    clearError(zonaId);
    if (!CONFIG.allowedFileTypes.includes(file.type)) { showError(zonaId, 'Formato no permitido. Usa JPG, PNG, SVG o PDF.'); return; }
    if (file.size/(1024*1024) > CONFIG.maxFileSizeMB) { showError(zonaId, 'Archivo demasiado grande.'); return; }
    if (!state.zones[zonaId]) state.zones[zonaId] = { tipo: 'A' };
    state.zones[zonaId].archivo = file; state.zones[zonaId].archivoNombre = file.name;
    var conf = document.querySelector('[data-zona-archivo-confirm="' + zonaId + '"]');
    if (conf) { conf.innerHTML = '<span class="calima-archivo-ok">\u2713</span><span class="calima-archivo-nombre">' + file.name + '</span><button type="button" class="calima-archivo-borrar" data-zona-borrar-archivo="' + zonaId + '">\u2715</button>'; conf.style.display = 'flex'; }
    if (file.type.startsWith('image/')) { var r = new FileReader(); r.onload = function(ev) { var m = document.querySelector('[data-zona-archivo-mini="' + zonaId + '"]'); if (m) { m.src = ev.target.result; m.style.display = 'block'; } }; r.readAsDataURL(file); }
  }

  function onArchivoBorrado(zonaId) {
    if (state.zones[zonaId]) { delete state.zones[zonaId].archivo; delete state.zones[zonaId].archivoNombre; }
    var c = document.querySelector('[data-zona-archivo-confirm="' + zonaId + '"]'); if (c) { c.innerHTML = ''; c.style.display = 'none'; }
    var m = document.querySelector('[data-zona-archivo-mini="' + zonaId + '"]'); if (m) { m.src = ''; m.style.display = 'none'; }
    var inp = document.querySelector('[data-zona-archivo-input="' + zonaId + '"]'); if (inp) inp.value = '';
  }

  function onZonaBToggle(zonaId, activa, precio) { if (activa) { state.zones[zonaId] = { tipo: 'B', precio: precio }; } else { delete state.zones[zonaId]; onArchivoBorrado(zonaId); } actualizarDisplay(); }
  function onTextoCambio(zonaId, texto, precio) { if (texto.trim()) { state.zones[zonaId] = { tipo: 'C', texto: texto.trim(), precio: precio }; } else { delete state.zones[zonaId]; } actualizarDisplay(); }
  function showError(zonaId, msg) { var el = document.querySelector('[data-zona-error="' + zonaId + '"]'); if (el) { el.textContent = msg; el.style.display = 'block'; } }
  function clearError(zonaId) { var el = document.querySelector('[data-zona-error="' + zonaId + '"]'); if (el) { el.textContent = ''; el.style.display = 'none'; } }

  function validar() {
    var ok = true;
    document.querySelectorAll('[data-zona-id]').forEach(function(el) {
      var id = el.dataset.zonaId, tipo = el.dataset.zonaTipo, ob = el.dataset.zonaObligatoria === 'true', z = state.zones[id];
      if (ob && !z) { showError(id, 'Esta zona es obligatoria.'); ok = false; return; }
      if (!z) return;
      if (tipo === 'A') { if (z.tamano && !z.archivo) { showError(id, 'Falta el archivo.'); ok = false; } if (z.archivo && !z.tamano) { showError(id, 'Falta el tamano.'); ok = false; } }
      if (tipo === 'B' && z.precio > 0 && !z.archivo) { showError(id, 'Falta el archivo.'); ok = false; }
    });
    return ok;
  }

  function buildProps() {
    var props = {};
    for (var id in state.zones) {
      var z = state.zones[id]; if (!z) continue;
      var el = document.querySelector('[data-zona-id="' + id + '"]'); var n = el ? (el.dataset.zonaNombre || id) : id;
      if (z.tipo === 'A' || z.tipo === 'B') { if (z.tamanoLabel) props[n + ' - Tamano'] = z.tamanoLabel; if (z.archivoNombre) props[n + ' - Archivo'] = z.archivoNombre; if (z.precio > 0) props[n + ' - Precio'] = formatPrice(z.precio); }
      if (z.tipo === 'C') { if (z.texto) props[n + ' - Texto'] = z.texto; if (z.precio > 0) props[n + ' - Precio'] = formatPrice(z.precio); }
    }
    return props;
  }

  function buildDesglose() {
    var parts = [];
    for (var id in state.zones) { var z = state.zones[id]; if (z && z.precio > 0) { var el = document.querySelector('[data-zona-id="' + id + '"]'); parts.push((el ? el.dataset.zonaNombre || id : id) + ': ' + formatPrice(z.precio)); } }
    return parts.join(' | ');
  }

  async function anadirAlCarrito() {
    if (state.submitting) return;
    if (!validar()) {
      if (window.calimaShowUploadModal) window.calimaShowUploadModal(null);
      return;
    }

    // Usar state.selectedVariantId primero - ya poblado por onVarianteChange
    // Solo buscar en DOM si state esta vacio
    if (!state.selectedVariantId || state.selectedVariantId <= 0) {
      var v = buscarVarianteEnDOM();
      if (v && v.id > 0) { state.selectedVariantId = v.id; if (v.talla) state.selectedVariantTitle = v.talla; }
    }

    if (!state.selectedVariantId || state.selectedVariantId <= 0) {
      var errEl = document.querySelector('[data-personalizer-error-general]');
      if (errEl) { errEl.textContent = 'Selecciona talla y color antes de continuar.'; errEl.style.display = 'block'; }
      return;
    }

    state.submitting = true; setLoading(true);
    try {
      var total = calcularPersonalizacion();
      var items = [{ id: state.selectedVariantId, quantity: 1, properties: buildProps() }];
      if (total > 0) {
        var entero = Math.round(total);
        var vid = CONFIG.personalizacionVariants[entero] || CONFIG.personalizacionVariants[1];
        var qty = CONFIG.personalizacionVariants[entero] ? 1 : entero;
        items.push({ id: vid, quantity: qty, properties: { 'Personalizacion': buildDesglose() } });
      }
      var r = await fetch('/cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ items: items }) });
      if (!r.ok) { var err = await r.json(); throw new Error(err.description || 'Error ' + r.status); }
      window.location.href = '/cart';
    } catch(e) {
      var errEl = document.querySelector('[data-personalizer-error-general]'); if (errEl) { errEl.textContent = 'Error: ' + e.message; errEl.style.display = 'block'; }
      console.error('[Calima] Cart error:', e);
    } finally { state.submitting = false; setLoading(false); }
  }

  function setLoading(on) {
    var btn = document.querySelector(CONFIG.containerSelector + ' [data-add-to-cart]'); if (!btn) return;
    btn.disabled = on;
    var t = btn.querySelector('.calima-personalizer__btn-texto'); if (t) t.style.display = on ? 'none' : '';
    var s = btn.querySelector('.calima-personalizer__btn-spinner'); if (s) s.style.display = on ? 'inline-flex' : 'none';
  }

  function bindEvents() {
    document.addEventListener('click', function(e) {
      var btn = e.target.closest('[data-zona-tamano-btn]'); if (btn) { onTamanoSelect(btn.dataset.zonaId, btn.dataset.tamano, btn.dataset.tamanoLabel || btn.dataset.tamano); return; }
      var lbl = e.target.closest('[data-archivo-label]'); if (lbl) { e.preventDefault(); var inp = document.querySelector('[data-zona-archivo-input="' + lbl.dataset.archivoLabel + '"]'); if (inp) inp.click(); return; }
      var del = e.target.closest('[data-zona-borrar-archivo]'); if (del) { onArchivoBorrado(del.dataset.zonaBorrarArchivo); return; }
      var cart = e.target.closest('#calima-personalizer [data-add-to-cart]'); if (cart) { e.preventDefault(); e.stopPropagation(); anadirAlCarrito(); }
    });
    document.addEventListener('change', function(e) {
      var t = e.target;
      if (t.type === 'file' && t.dataset.zonaArchivoInput && t.files && t.files[0]) { onArchivoSubido(t.dataset.zonaArchivoInput, t.files[0]); return; }
      if (t.type === 'checkbox' && t.dataset.zonaBToggle) { onZonaBToggle(t.dataset.zonaBToggle, t.checked, parseFloat(t.dataset.precioFijo) || 0); }
    });
    document.addEventListener('input', function(e) { var t = e.target; if (t.hasAttribute('data-zona-texto')) { onTextoCambio(t.dataset.zonaId, t.value, parseFloat(t.dataset.precioFijo) || 0); } });
  }

  function init() {
    if (!getContainer()) return;
    state.basePrice = readBasePrice();
    initVariant();
    actualizarDisplay();
    document.querySelectorAll('[data-zona-id]').forEach(function(el) { if (el.dataset.zonaTipo === 'A') actualizarBotones(el.dataset.zonaId); });
    bindEvents();
    var queue = window._calimaQueue || [];
    window._calimaQueue = { push: function(args) { onVarianteChange(args[0], args[1]); } };
    if (Array.isArray(queue)) queue.forEach(function(args) { onVarianteChange(args[0], args[1]); });
    console.log('[Calima v6] OK | variantId:', state.selectedVariantId, '| talla:', state.selectedVariantTitle);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();

  return { state, init, formatPrice, onVarianteChange, onTamanoSelect, onArchivoSubido, onArchivoBorrado, onZonaBToggle, onTextoCambio, anadirAlCarrito };

})();